import React, {
  useEffect,
  useRef
} from "react";

import {
  FontAwesomeIcon
} from "@fortawesome/react-fontawesome";

import {
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";

import {
  useNavigate
} from "react-router-dom";

import googleicon from "../header/images/googleicon.png";
import linkedinicon from "../imagesHome/share-linkedin.png";

import "./sociallogin.css";


const apiUrl =
  process.env.REACT_APP_API_URL;

const clientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID;


const SocialLogin = ({
  allowDirectSignup = false,
  redirectAfterLogin = "/functionalpagelogin"
}) => {

  const navigate =
    useNavigate();

  const navigateRef =
    useRef(navigate);

  navigateRef.current =
    navigate;


  /* ============================================
     PARAMETRI LOGIN
  ============================================ */

  const sourceQuery =
    allowDirectSignup
      ? "&source=login-page"
      : "";

  const redirectQuery =
    redirectAfterLogin &&
    redirectAfterLogin !== "/functionalpagelogin"
      ? `&redirect=${encodeURIComponent(
          redirectAfterLogin
        )}`
      : "";


  /* ============================================
     DESTINATIE DUPA LOGIN
  ============================================ */

  const getDestinationAfterLogin = () => {

    if (
      redirectAfterLogin === "/planlunar"
    ) {
      return "/functionalpagelogin?premiumPlan=monthly";
    }


    if (
      redirectAfterLogin === "/plan3luni"
    ) {
      return "/functionalpagelogin?premiumPlan=three-months";
    }


    return "/redirecting";
  };


  /* ============================================
     GOOGLE LOGIN
  ============================================ */

  const handleGoogleLogin = () => {

    window.location.href =
      `${apiUrl}/auth/google?flow=login${sourceQuery}${redirectQuery}`;

  };


  /* ============================================
     LINKEDIN LOGIN
  ============================================ */

  const handleLinkedInLogin = () => {

    window.location.href =
      `${apiUrl}/auth/linkedin?flow=login${sourceQuery}${redirectQuery}`;

  };


  /* ============================================
     GOOGLE ONE TAP
  ============================================ */

  const handleCredentialResponse = (
    response
  ) => {

    fetch(
      `${apiUrl}/google-onetap-login`,
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        credentials:
          "include",

        body:
          JSON.stringify({
            token:
              response.credential
          })
      }
    )

      .then(async (res) => {

        const data =
          await res.json();


        /* ======================================
           LOGIN REUSIT
        ====================================== */

        if (
          res.ok &&
          data.message ===
            "Autentificat cu succes"
        ) {

          const destination =
            getDestinationAfterLogin();

          navigateRef.current(
            destination,
            {
              replace: true
            }
          );

          return;
        }


        /* ======================================
           USER INEXISTENT
        ====================================== */

        if (
          res.status === 404 &&
          data.code ===
            "USER_NOT_FOUND"
        ) {

          const onboardingUrl =
            redirectAfterLogin &&
            redirectAfterLogin !==
              "/functionalpagelogin"
              ? `/onboarding-intro?redirect=${encodeURIComponent(
                  redirectAfterLogin
                )}`
              : "/onboarding-intro";


          navigateRef.current(
            onboardingUrl,
            {
              replace: true
            }
          );

          return;
        }


        /* ======================================
           ERROR LOGIN
        ====================================== */

        const message =
          data?.message ||
          "Autentificarea cu Google a esuat.";


        const loginUrl =
          redirectAfterLogin &&
          redirectAfterLogin !==
            "/functionalpagelogin"
            ? `/login?error=${encodeURIComponent(
                message
              )}&redirect=${encodeURIComponent(
                redirectAfterLogin
              )}`
            : `/login?error=${encodeURIComponent(
                message
              )}`;


        navigateRef.current(
          loginUrl,
          {
            replace: true
          }
        );

      })


      .catch((err) => {

        console.error(
          "Eroare One Tap:",
          err
        );


        const message =
          "Autentificarea cu Google a esuat.";


        const loginUrl =
          redirectAfterLogin &&
          redirectAfterLogin !==
            "/functionalpagelogin"
            ? `/login?error=${encodeURIComponent(
                message
              )}&redirect=${encodeURIComponent(
                redirectAfterLogin
              )}`
            : `/login?error=${encodeURIComponent(
                message
              )}`;


        navigateRef.current(
          loginUrl,
          {
            replace: true
          }
        );

      });

  };


  /* ============================================
     GOOGLE ONE TAP INITIALIZE
  ============================================ */

  useEffect(() => {

    if (
      window.google &&
      clientId
    ) {

      window.google.accounts.id.initialize({

        client_id:
          clientId,

        callback:
          handleCredentialResponse

      });


      window.google.accounts.id.prompt();

    }

  }, []);


  /* ============================================
     EMAIL LOGIN
  ============================================ */

  const handleEmailLogin = () => {

    if (
      redirectAfterLogin &&
      redirectAfterLogin !==
        "/functionalpagelogin"
    ) {

      navigate(
        `/emailconnect?redirect=${encodeURIComponent(
          redirectAfterLogin
        )}`
      );

      return;
    }


    navigate(
      "/emailconnect"
    );

  };


  /* ============================================
     RENDER
  ============================================ */

  return (

    <div className="options-connect">


      {/* GOOGLE */}

      <div
        className="connect-social google"
        onClick={handleGoogleLogin}
      >

        <img
          src={googleicon}
          alt="google icon"
        />

        <span>
          Conectare cu Google
        </span>

      </div>


      {/* LINKEDIN */}

      <div
        className="connect-social linkedin"
        onClick={handleLinkedInLogin}
      >

        <img
          src={linkedinicon}
          alt="linkedin icon"
        />

        <span>
          Conectare cu LinkedIn
        </span>

      </div>


      {/* EMAIL */}

      <div
        className="connect-social email"
        onClick={handleEmailLogin}
      >

        <FontAwesomeIcon
          icon={faEnvelope}
        />

        <span className="email-color">
          Conectare cu email
        </span>

      </div>


    </div>

  );

};


export default SocialLogin;